export default "__VITE_ASSET__D4mwz0Ie__"